import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import { Subject } from 'rxjs';
import {User} from "../models";

@Component({
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnDestroy, OnInit {

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService
    ) { }

    ngOnInit() {

    }

    ngOnDestroy(): void {

    }

    getUserData(): User {
        return this.accountService.userValue;
    }
}
